import React from 'react';
import { navigate } from 'gatsby';
import SearchIcon from '@material-ui/icons/Search';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import { urlParamsFromObject } from '../../utils/url';
import './style.css';

class DocSearch extends React.Component {
    state = {
        enabled: true,
        search: '',
    };

    constructor(props) {
        super(props);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onSearchTermUpdate = this.onSearchTermUpdate.bind(this);
    }

    onFormSubmit(e) {
        e.preventDefault();
        if (this.state.search === '') {
            return;
        }
        const urlParams = { query: this.state.search };
        navigate(`/search/?${urlParamsFromObject(urlParams)}`);
    }

    onSearchTermUpdate(e) {
        this.setState({ search: e.target.value });
    }

    render() {
        const { enabled } = this.state;

        return enabled ? (
            <form className={'form-style'} onSubmit={this.onFormSubmit}>
                <Input
                    className={'search-input'}
                    onChange={this.onSearchTermUpdate}
                    disableUnderline={true}
                    id="algolia-doc-search"
                    type="search"
                    placeholder="SEARCH HELP"
                    aria-label="Search docs"
                    margin={'dense'}
                    startAdornment={
                        <InputAdornment position={'start'}>
                            <SearchIcon style={{ color: '#636363' }} />
                        </InputAdornment>
                    }
                />
            </form>
        ) : null;
    }
}

export default DocSearch;
